<template>
    <v-text-field
      v-model="inputValue"
      :label="label"
      class="w-100"
      outlined
      dense
      hide-details
      clearable
      @input="onInput"
    />
  </template>
  
  <script>
  export default {
    name: "TextSearch",
    props: {
      value: {
        type: String,
        default: '',
      },
      label: {
        type: String,
        default: 'Cari',
      }
    },
    data() {
      return {
        inputValue: this.value
      }
    },
    watch: {
      value(val) {
        this.inputValue = val;
      }
    },
    methods: {
      onInput(val) {
        this.$emit('input', val); // For v-model
        this.$emit('update:modelValue', val); // Optional if using v-model: 'modelValue'
      }
    }
  }
  </script>
  